export const getQueryParam = (search: string) => {
  const regex = new RegExp('[?&]' + search + '=([^&]+).*$');
  const match = window.location.search.match(regex);
  return match ? match[1] : null;
};
